import React from "react"
import PropTypes from "prop-types"
import { Container, Box, CloseButton, MobileOnly, LoadingContainer } from "./styles"
import LoadingSpinner from "../loading-spinner"
import * as Sections from "./sections"
import SpaContentNav from "../spa-content-nav"
import { DesktopOnly } from "../profile-info/styles"

const sectionsMap = {
  form: Sections.Form,
  interviews: Sections.Interviews,
  overview: Sections.Overview,
  preferences: Sections.Preferences,
  references: Sections.References,
  skill: Sections.Skills,
  flight: Sections.TravelAndFlights,
  work_experience: Sections.WorkExperience,
  work_permit: Sections.WorkPermit,
  photos_and_videos: Sections.PhotosAndVideos,
  location: Sections.Location,
  rp_interview_summary: Sections.RpInterviewSummary,
  linked_application: Sections.LinkedApplication
}

const headerMap = {
  participant: Sections.ParticipantHeader,
  employer: Sections.EmployerHeader
}

const Profile = ({
  show,
  loading,
  disclaimer,
  noteInfo,
  employer,
  sections,
  toggle,
  profileData,
  openReference,
  toggleProfile,
  onRequestInterview,
  onInterview,
  bookInterviewSelectedSkill,
  bookInterviewSection,
  setSelected,
  initialSection,
  addComment,
  removeComment,
  activityLogs
}) => {
  const displaySmallSize = addComment === undefined && profileData.key === "participant"
  const displayFullSize = addComment !== undefined
  const maskVerticalOffset = 27
  if (loading) {
    return (
      <Container show={true} maskVerticalOffset={maskVerticalOffset}>
        <Box fullSize={displayFullSize} smallSize={displaySmallSize}>
          {Header && <Header></Header>}
          <LoadingContainer>
            <LoadingSpinner variant="primary" />
          </LoadingContainer>
        </Box>
      </Container>
    )
  }

  const Header = headerMap[profileData.key]
  const headerRef = React.createRef()
  const boxRef = React.createRef()
  const hasCoverImage = false

  const participantMode = profileData.data.application_container_id !== undefined

  return (
    <Container show={show} onClick={toggle} maskVerticalOffset={maskVerticalOffset}>
      <Box
        ref={boxRef}
        scrollable={true}
        onClick={(event) => event.stopPropagation()}
        fullSize={displayFullSize}
        smallSize={displaySmallSize}
      >
        <DesktopOnly>
          <Header {...profileData.data} hasCoverImage={hasCoverImage} ref={headerRef} />
        </DesktopOnly>
        <SpaContentNav
          sections={sections}
          sectionsMap={sectionsMap}
          disclaimer={disclaimer}
          noteInfo={noteInfo}
          employer={employer}
          openReference={openReference}
          toggleProfile={toggleProfile}
          mobileScrollingBoxRef={boxRef}
          mobileHeaderRef={headerRef}
          close={toggle}
          portalType={profileData.portalType}
          onRequestInterview={onRequestInterview}
          onInterview={onInterview}
          bookInterviewSelectedSkill={bookInterviewSelectedSkill}
          bookInterviewSection={bookInterviewSection}
          initialSection={initialSection}
          setSelectedOuter={setSelected}
          avatarUrl={profileData.data.avatar_path}
          avatarExists={profileData.data.avatar_exists}
          obfuscated={profileData.data.obfuscated}
          employerName={profileData.data.employer_name}
          firstName={profileData.data.first_name}
          lastName={profileData.data.last_name}
          buttonValues={profileData.data.buttonValues}
          applicationContainerId={profileData.data.application_container_id}
          addComment={addComment}
          removeComment={removeComment}
          activityLogs={activityLogs}
          headerComponent={<Header {...profileData.data} hasCoverImage={hasCoverImage} ref={headerRef} />}
        />
        <CloseButton size="large" body={hasCoverImage} onClick={toggle} participantMode={participantMode} />
      </Box>
    </Container>
  )
}

Profile.propTypes = {
  show: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  disclaimer: PropTypes.node,
  noteInfo: PropTypes.object,
  toggle: PropTypes.func.isRequired,
  openReference: PropTypes.func,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired
    })
  ).isRequired,
  profileData: PropTypes.shape({
    key: PropTypes.oneOf(["participant", "employer"]).isRequired,
    data: PropTypes.object.isRequired
  }).isRequired,
  employer: PropTypes.object,
  bookInterviewSelectedSkill: PropTypes.string,
  bookInterviewSection: PropTypes.element,
  onRequestInterview: PropTypes.func,
  onInterview: PropTypes.func,
  setSelected: PropTypes.func,
  initialSection: PropTypes.string
}

Profile.defaultProps = {
  show: false,
  loading: false,
  toggle: undefined,
  openReference: undefined,
  toggleProfile: undefined,
  sections: [],
  sidebar: {
    key: "",
    data: {}
  },
  employer: {},
  bookInterviewSection: null,
  onRequestInterview: () => {},
  onInterview: () => {},
  setSelected: () => {},
  bookInterviewSelectedSkill: "",
  initialSection: ""
}

export default Profile
